module.exports = __webpack_public_path__ + "img/1f98f.7132472.svg";